export const dataHooks = {
  feature: 'feature',
  featureImage: 'featureImage',
  featureTitle: 'featureTitle',
  featureText: 'featureText',
};
